import { render, staticRenderFns } from "./Pharmacist.vue?vue&type=template&id=24d97823&scoped=true&"
import script from "./Pharmacist.vue?vue&type=script&lang=js&"
export * from "./Pharmacist.vue?vue&type=script&lang=js&"
import style0 from "./Pharmacist.vue?vue&type=style&index=0&id=24d97823&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d97823",
  null
  
)

export default component.exports